module.exports = __webpack_public_path__ + "img/loading.9c4e91e8.gif";